import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "918103803294";
const WA_TEXT = encodeURIComponent("Hello ZALTA, I want to enquire about institutional bulk orders.");

export const WhatsAppButton = () => (
  <a
    data-testid="whatsapp-float-btn"
    href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WA_TEXT}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="WhatsApp enquiry"
    className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1EBE5B] text-white flex items-center justify-center shadow-[0_12px_30px_-8px_rgba(37,211,102,0.6)] transition-colors duration-300 active:scale-90"
  >
    <MessageCircle size={24} />
  </a>
);
